import { render, staticRenderFns } from "./StudentGraduation.vue?vue&type=template&id=f7c4d522&scoped=true"
import script from "./StudentGraduation.vue?vue&type=script&lang=js"
export * from "./StudentGraduation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c4d522",
  null
  
)

export default component.exports